module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zgbs-dialog-wrap"
  }, [(!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("多场景展示："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("在您的求职中心、简历页面、全职招聘页面增加皇冠标识，让您的身份与众不同。")])]), _vm._v(" "), _c('div', {
    staticClass: "zgbs-bg"
  }, [_c('img', {
    staticClass: "zgbs-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-zgbs.png")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("尊贵标识")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("多场景展示：在您的求职中心、简历页面、全职招聘页面增加皇冠标识，让您的身份与众不同。")])]), _vm._v(" "), _c('div', {
    staticClass: "zgbs-bg"
  }, [_c('img', {
    staticClass: "zgbs-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-zgbs.png")
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76931d61"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/ZgbsDialog.vue
// module id = iuUc
// module chunks = 1